import Component from './InDmChatRow.vue'
export default Component
export * from './types'
